module.exports = __webpack_public_path__ + "static/media/tools.327ec950.svg";